module.exports = __webpack_public_path__ + "img/logointeiro-findme.5ec877d0.png";